import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, withRouter } from 'react-router';

import { ModelsPage } from '@mpm-druid/components/ModelsPage';

const ModelProductionMonitoringRoutes = ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.path}/:modelId`} component={ModelsPage} />
    </Switch>
  );
};

ModelProductionMonitoringRoutes.propTypes = {
  match: PropTypes.object.isRequired
};

export default withRouter(ModelProductionMonitoringRoutes);
